import { IconButton, Tooltip } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ISegmentFilter } from '../../../../../entities/offsiteCampaign';
import { State as CampaignState } from 'entities/lifecycle/lifeCycle';
import styled from 'styled-components';

const FilterRow = styled.div`
  display: flex;
  background-color: white;
  border: 1px solid darkgrey;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
`;

// const FilterInputs = styled.div`
//   display: flex;
//   gap: 5px;
//   padding: 5px 10px;
//   justify-content: stretch;
//   width: 100%;
//   align-items: center;
// `;

// const FilterElement = styled.span`
//   padding: 2px 5px;
//   border-radius: 3px;
//   background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
//   cursor: pointer;
//   font-weight: bold;
//   color: ${({ theme }) => theme.vars.newColor.blue2};
//   &:hover {
//     color: ${({ theme }) => theme.vars.newColor.blue3};
//   }
//   &:last-child {
//     width: 100%;
//   }
//   &:first-child {
//     padding: 4px 5px;
//     flex-shrink: 0;
//   }
// `;

// const FilterInput = styled.input`
//   border: 0;
//   background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
//   display: flex;
//   flex-grow: 1;
//   padding: 2px 5px;
//   border-radius: 3px;
//   color: ${({ theme }) => theme.vars.newColor.blue2};
//   font-weight: bold;
//   &:hover {
//     color: ${({ theme }) => theme.vars.newColor.blue3};
//   }
//   cursor: pointer;
// `;

interface OwnProps {
  segmentId: string;
  segmentFilter: ISegmentFilter;
  index: number;
  campaignState: CampaignState;
  onFilterClick: (filterInfo: FilterInfo) => void;
}

export type FilterInfo = {
  filterId: string;
  comparison: string;
  filterValue: string;
};

export type Props = OwnProps;

export const Filter: FC<Props> = props => {
  const { t } = useTranslation();

  return (
    <FilterRow>
      <Tooltip title={t('campaigns:offsiteEditor.segments.filters.delete.iconAriaLabel')} position="top">
        <IconButton
          ariaLabel={t('campaigns:offsiteEditor.segments.filters.delete.iconAriaLabel')}
          icon="trash"
          data-testid="delete-segment-filter-button"
        />
      </Tooltip>
    </FilterRow>
  );
};
